import type { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export type PasswordFormErrors = Partial<
    Record<'oldPassword' | 'password' | 'passwordConfirmation' | 'form', string>
>;

export const mapPasswordFormErrors = (
    errors: IDataResponseError['errors'] = []
): PasswordFormErrors =>
    errors.reduce<PasswordFormErrors>((acc, error) => {
        switch (error.source.pointer) {
            case 'old_password':
            case 'oldPassword':
                acc.oldPassword = error.title;
                break;
            case 'password':
            case 'plainPassword':
                acc.password = error.title;
                break;
            case 'password_confirmation':
                acc.passwordConfirmation = error.title;
                break;
            default:
                acc.form = error.title;
        }

        return acc;
    }, {});
